import { activeRequests, addActiveRequest, deleteActiveRequest } from '../../utils/network';
import API from '../../utils/api';
import {
    INCREASE_REPORTS_CLEARED,
    INCREASE_REPORTS_FETCHED,
    INCREASE_REPORTS_FETCHING_CHANGED,
    INCREASE_REPORTS_FILTERS_DATES_CHANGED,
    INCREASE_REPORTS_FILTERS_STATUS_CHANGED,
    INCREASE_REPORTS_HAS_MORE_CHANGED,
    INCREASE_REPORTS_PAGE_CHANGED,
    INCREASE_REPORTS_PAGINATED,
    INCREASE_REPORTS_PAGINATING_CHANGED,
} from './types';
import { AGENT_SERVICE_ENDPOINT_URL } from '../../constants/defaultValues';
import AgentService from '../../services/AgentService';
import { formatMessage, getTranslation } from '../../utils/translation';
import { getUserAccount } from './user';
import { changeIncreaseCreditModalProps } from './modals';

export const getIncreaseReports =
    (query = {}) =>
    async (dispatch, getStore) => {
        const shouldClearReports = query.offset === 0;
        if (shouldClearReports) {
            dispatch(clearIncreaseReports());
        }

        const timestamp = new Date().getTime();
        const activeRequestKey = 'GET/agent/balance';
        deleteActiveRequest(activeRequestKey);
        addActiveRequest(activeRequestKey, timestamp);

        try {
            if (shouldClearReports) {
                dispatch(changeIncreaseReportsFetching(true));
            } else {
                dispatch(changeIncreaseReportsPaginating(true));
            }
            const response = await API.get(`${AGENT_SERVICE_ENDPOINT_URL}/balance`, {
                params: query,
            });

            const { info, item } = response.data;

            if (!info.success) {
                const reduxStore = getStore();
                const currentPage = reduxStore.increaseReports.currentPage;
                dispatch(changeIncreaseReportsPage(currentPage - 1));

                if (shouldClearReports) {
                    dispatch(changeIncreaseReportsFetching(false));
                } else {
                    dispatch(changeIncreaseReportsPaginating(false));
                }

                return;
            }

            const { internalPayments } = item;

            if (internalPayments.length >= query.limit) {
                dispatch(changeIncreaseReportsHasMore(true));
            } else {
                dispatch(changeIncreaseReportsHasMore(false));
            }

            const activeRequestTimestamp = activeRequests[activeRequestKey];
            if (timestamp !== activeRequestTimestamp) return;

            if (shouldClearReports) {
                dispatch({
                    type: INCREASE_REPORTS_FETCHED,
                    payload: internalPayments,
                });
            } else {
                dispatch({
                    type: INCREASE_REPORTS_PAGINATED,
                    payload: internalPayments,
                });
            }
        } catch (error) {
            console.error({ error });

            if (shouldClearReports) {
                dispatch(changeIncreaseReportsFetching(false));
            } else {
                dispatch(changeIncreaseReportsPaginating(false));
            }
        }
    };

export const increaseDebt = () => async dispatch => {
    try {
        const response = await AgentService.increaseDebt();

        const { info, item } = response.data;

        if (!info.success) {
            dispatch(
                changeIncreaseCreditModalProps({
                    isVisible: true,
                    errorResponse: { message: info.errors[0]?.reason },
                })
            );
            return;
        }

        const { amount } = item;

        dispatch(getUserAccount());

        dispatch(
            changeIncreaseCreditModalProps({
                isVisible: true,
                successResponse: {
                    message: formatMessage(getTranslation('increaseInterimCreditSuccess'), {
                        amount,
                    }),
                },
            })
        );
    } catch (error) {
        console.error({ error });
        dispatch(
            changeIncreaseCreditModalProps({
                isVisible: true,
                errorResponse: {
                    message:
                        error.response?.data?.info?.errors[0].reason ||
                        getTranslation('generalErrorModalTitle'),
                },
            })
        );
    }
};

export const changeIncreaseReportsDates = dates => ({
    type: INCREASE_REPORTS_FILTERS_DATES_CHANGED,
    payload: dates,
});

export const changeIncreaseReportsSelectedStatus = status => ({
    type: INCREASE_REPORTS_FILTERS_STATUS_CHANGED,
    payload: status,
});

export const changeIncreaseReportsPage = page => ({
    type: INCREASE_REPORTS_PAGE_CHANGED,
    payload: page,
});

export const changeIncreaseReportsHasMore = hasMore => ({
    type: INCREASE_REPORTS_HAS_MORE_CHANGED,
    payload: hasMore,
});

export const changeIncreaseReportsPaginating = isPaginating => ({
    type: INCREASE_REPORTS_PAGINATING_CHANGED,
    payload: isPaginating,
});

export const changeIncreaseReportsFetching = isFetching => ({
    type: INCREASE_REPORTS_FETCHING_CHANGED,
    payload: isFetching,
});

export const clearIncreaseReports = () => ({
    type: INCREASE_REPORTS_CLEARED,
});
